import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-181" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-182" data-mp="o4713081h8ii">
        <SectionHeading id="summary-title" data-id="element-183" data-mp="j7yfb3zc6h2d">Everything <span className="text-accent" data-id="element-184" data-mp="j53tb80oco6u">Included:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-primary/60 bg-surface/85 sm:grid-cols-2" data-id="element-185" data-mp="1gtmc3pzpf1ef">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-primary/15 p-4 sm:odd:border-r" data-id="element-186" data-mp="16wrd75ziqyzm">
              <span className="glow-line mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-highlight" data-id="element-187" data-mp="12vft1fzez5yt">
                <CheckIcon className="h-3.5 w-3.5 text-background" aria-hidden="true" data-id="element-188" data-mp="3ro1j2ynbvllf" />
              </span>
              <b className="text-sm text-foreground" data-id="element-189" data-mp="3nklrwhu12dg4">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}